export default __webpack_public_path__ + "images/logoSaltAndStone.be76ff080db2e2e41b36463a5256e2f1.svg"